import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import './slider-home.scss'

import gym from '../../../assets/images/banner-home/slider-gym.png'
import asientogym from '../../../assets/images/banner-home/slider-asiento-gym.png'
import bus from '../../../assets/images/banner-home/slider-bus.png'
import asientobus from '../../../assets/images/banner-home/slider-asiento-bus.png'

import gymMb from '../../../assets/images/banner-home/slider-gym-mb.png'
import busMb from '../../../assets/images/banner-home/slider-bus-mb.png'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
const SliderHome = () => {
  const isMobile = useMediaQuery()
  var refSlider = null
  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    draggable: false,
    autoplay: true,
    autoplaySpeed: 1500,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <div className="f-slider-home --masked">
      <Slider ref={slider => (refSlider = slider)} {...sliderSettings}>
        <img
          alt="señorita ejercitandose"
          className="f-slider-home__image "
          src={isMobile ? gymMb : gym}
        />
        <img
          alt="asiento gym con particulas "
          className="f-slider-home__image "
          src={asientogym}
        />
        <img
          alt="señorita sentada en un bus"
          className="f-slider-home__image "
          src={isMobile ? busMb : bus}
        />
        <img
          alt="asiento gym con particulas "
          className="f-slider-home__image "
          src={asientobus}
        />
      </Slider>
    </div>
  )
}
export default SliderHome
